import { render, staticRenderFns } from "./BookingInventoryProductDetails.vue?vue&type=template&id=6878e583&scoped=true&"
import script from "./BookingInventoryProductDetails.vue?vue&type=script&lang=ts&"
export * from "./BookingInventoryProductDetails.vue?vue&type=script&lang=ts&"
import style0 from "./BookingInventoryProductDetails.vue?vue&type=style&index=0&id=6878e583&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6878e583",
  null
  
)

export default component.exports